<template>
  <a-modal :visible="visible" title="批量导入" @ok="handleOk" @cancel="handleCancel">
    <div class="head-btn">
      <a-upload
        name="file"
        :multiple="false"
        :action="url"
        :headers="headers"
        :beforeUpload="beforeUpload"
        @change="handleChange"
        :showUploadList="false"
        >
        导入文件：<a-button><a-icon type="cloud-upload" />选择Excel文件</a-button>
      </a-upload>
      <div>
        <a-button type="primary" @click="exportClick"><a-icon type="arrow-down" />模板下载</a-button>
      </div>
    </div>
    <div class="tips">
      <span style="color: red">导入须知：</span>
      <span>导入数据需按模板指定格式进行导入：1、姓名、帐号为必填字段，组织名称列以“/”开头，下级组织同样用“/”分隔； 3、邮箱格式必须符合标准，将不导入不符合规范的邮箱数据。</span>
    </div>
  </a-modal>
</template>
<script>
import { getStorage } from '@/utils/index'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: Array,
      default: () => []
    },
    url: {
      type: String,
      default: ''
    },
    deptId: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      headers: {},
      info: {}
    };
  },
  mounted() {
      const token = `${getStorage('token', 0)}`
      this.headers = {
        Authorization: token
      }
  },
  methods: {
    handleOk() {
      this.$emit('ok')
    },
    handleCancel() {
      this.$emit('cancel')
    },
    async exportClick () {
      const elink = document.createElement('a')
      elink.setAttribute('download', '用户信息模板')
      elink.setAttribute('href', '/smartFile/template/user_template.xlsx')
      elink.click()
      document.body.removeChild(elink)
    },
    beforeUpload(file) {
      const { name } = file
      const type = name.split('.').slice(-1)[0]
      if (this.type.indexOf(type) === -1) {
        this.$apiStatusHandler(99, '上传的附件类型不符合要求')
        return Promise.reject()
      }
    },
    handleChange(e) {
      if (e.file.status === 'done') {
        //const { code, msg, data } = e.file.response
        this.handleOk()
        this.$emit('upload', e.file.response)
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.head-btn{
  display: flex;
  justify-content: space-between;
}
.tips{
  margin-top: 50px;
}
</style>